module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "teinte"
    }
  }, [_c('section', {
    attrs: {
      "id": "teinteDesktop"
    }
  }, [_c('div', {
    staticClass: "rel",
    attrs: {
      "id": "Teinte"
    }
  }, [_c('h3', {
    staticClass: "txtCenter ff-medium rel",
    attrs: {
      "id": "title"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("shades.title")) + "\n                "), (_vm.hasAccessCreate('shade_manager')) ? _c('button', {
    staticClass: "btn abs pointer mobileNot ff-light",
    attrs: {
      "id": "edit"
    },
    on: {
      "click": function($event) {
        _vm.modalShades();
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("shades.add")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.loading === false && _vm.hasAccessUpdateAndCreate('shade_manager')) ? _c('div', {
    staticClass: "uploader-form btn abs pointer mobileNot ff-light"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "action": _vm.actionUrl,
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "uploader-form-input"
  }, [_c('input', {
    ref: "fileUpload",
    staticClass: "hidden",
    attrs: {
      "id": "fileUpload",
      "type": "file",
      "name": _vm.uploadFieldName,
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": function($event) {
        _vm.onSubmit($event.target);
        _vm.fileCount = $event.target.files.length;
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.chooseFiles();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("shades.import")))])])])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "arrows mobileOnly abs",
    on: {
      "click": _vm.showShades
    }
  }, [(_vm.displayArrowUp) ? _c('img', {
    staticClass: "fright",
    attrs: {
      "id": "upArrow",
      "src": require("../../assets/chev-up.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayArrowDown) ? _c('img', {
    staticClass: "fright",
    attrs: {
      "id": "downArrow",
      "src": require("../../assets/chev-down.png"),
      "alt": ""
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.totalActiveShades !== 0 || _vm.totalZoneShades !== 0 || _vm.totalAllShades !== 0) ? _c('ul', {
    staticClass: "flexContainer fw-w jc-c mobileNot listNone",
    attrs: {
      "id": "typeOfShades"
    }
  }, [_c('li', {
    staticClass: "ff-light",
    class: {
      active: _vm.activeShades
    },
    on: {
      "click": _vm.displayActiveShades
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("shades.allActive")) + " (" + _vm._s(_vm.totalActiveShades) + ")\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "ff-light",
    class: {
      active: _vm.zoneShades
    },
    on: {
      "click": _vm.displayZoneShades
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("shades.zoneShades")) + " (" + _vm._s(_vm.totalZoneShades) + ")\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "ff-light",
    class: {
      active: _vm.allShades
    },
    on: {
      "click": _vm.displayAllShades
    }
  }, [_vm._v(_vm._s(_vm.$t("shades.allShades")) + " (" + _vm._s(_vm.totalAllShades) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.totalActiveShades === 0 && _vm.totalZoneShades === 0 && _vm.totalAllShades === 0) ? _c('h2', {
    staticClass: "txtCenter ff-medium uppercase"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("shades.noShades")) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rel shadesPosition flexContainer fw-w mobileNot",
    attrs: {
      "id": "shadesPosition"
    }
  }, [_vm._l((_vm.getRelatedShades), function(shade, index) {
    return (_vm.activeShades === shade.activated || _vm.allShades || _vm.zoneShades) ? _c('div', {
      key: shade.id,
      staticClass: "shades size1of6 flexContainer fd-c ai-c jc-fs rel",
      class: _vm.shadeClass(index),
      on: {
        "mouseleave": _vm.mouseLeave
      }
    }, [_c('div', {
      staticClass: "colors",
      class: {
        animation: shade.isDiscontinued == false || shade.isDiscontinued == null
      }
    }, [_c('div', {
      class: {
        colorCertifAct: shade.isCertified == true && shade.activated == true,
          colorCertiDis: shade.isCertified == true && shade.isDiscontinued == true
      }
    }, [(shade.properties.hasOwnProperty('colors')) ? _c('div', {
      staticClass: "circle fleft pointer",
      class: {
        shadeActive: shade.activated == true, shadeDisabled: shade.isDiscontinued == true
      },
      style: ('background:' + shade.properties.colors.color.value + ';'),
      on: {
        "mouseover": function($event) {
          _vm.hoverInfo(shade.id);
        },
        "click": function($event) {
          _vm.editShade(shade.id);
        }
      }
    }) : _c('div', {
      staticClass: "circle fleft",
      class: {
        shadeActive: shade.activated == true, shadeDisabled: shade.isDiscontinued == true
      },
      style: ('background: #fff;'),
      on: {
        "mouseover": function($event) {
          _vm.hoverInfo(shade.id);
        },
        "click": function($event) {
          _vm.editShade(shade.id);
        }
      }
    })]), _vm._v(" "), _c('div', {
      class: {
        whenCertified: shade.isCertified === true,
          whenNotCertified: shade.isCertified === null || shade.isCertified === false
      },
      attrs: {
        "id": 'shadeNames_' + shade.id
      }
    }, [(shade.properties.hasOwnProperty('number')) ? _c('span', [_vm._v(_vm._s(shade.properties.number.numb1.value) + " ")]) : _vm._e(), _vm._v(" " + _vm._s(shade.name) + "\n                        "), _c('br'), _vm._v(" "), (shade.properties.hasOwnProperty('reference') && shade.properties.reference.hasOwnProperty('client_ref1')) ? _c('span', [_vm._v(_vm._s(shade.properties.reference.client_ref1.value))]) : _vm._e()])]), _vm._v(" "), (_vm.currentShade.id == shade.id) ? _c('ShadeHover', {
      attrs: {
        "index": index,
        "shade": _vm.currentShade
      }
    }) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  })], 2)]), _vm._v(" "), (_vm.displayShades) ? _c('section', {
    staticClass: "mobileOnly full rel",
    attrs: {
      "id": "teinteMobile"
    }
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bonjour),
      expression: "bonjour"
    }],
    staticClass: "block center ff-medium",
    attrs: {
      "id": "shades"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bonjour = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.typeOfShades();
      }]
    }
  }, [_c('option', [_vm._v(" " + _vm._s(_vm.$t("shades.allActive")) + " (" + _vm._s(_vm.totalActiveShades) + ")")]), _vm._v(" "), _c('option', [_vm._v(" " + _vm._s(_vm.$t("shades.zoneShades")) + " (" + _vm._s(_vm.totalZoneShades) + ")")]), _vm._v(" "), _c('option', [_vm._v(" " + _vm._s(_vm.$t("shades.allShades")) + " (" + _vm._s(_vm.totalAllShades) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "mobileOnly"
  }, [_c('div', {
    staticClass: "flexContainer m-fw-w m-jc-sb "
  }, _vm._l((_vm.getRelatedShades), function(shades, index) {
    return (_vm.activeShades === shades.activated || _vm.allShades || _vm.zoneShades) ? _c('div', {
      key: shades.properties.colors.color.value,
      staticClass: "shades size1of2",
      class: _vm.shadeClass(index)
    }, [_c('div', {
      staticClass: "colors"
    }, [_c('div', {
      staticClass: "circle center",
      class: {
        shadeActive: shades.activated == true, shadeDisabled: shades.activated == false
      },
      style: ('background:' + shades.properties.colors.color.value + ';'),
      attrs: {
        "exact": ""
      }
    }), _vm._v(" "), (shades.properties.hasOwnProperty('number')) ? _c('p', {
      staticClass: "txtCenter"
    }, [_c('span', {
      staticClass: "colorNameMob ff-light"
    }, [_vm._v(_vm._s(shades.properties.number.numb1.value) + " " + _vm._s(shades.name))])]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e()
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('CreateShade', {
    on: {
      "hide": function($event) {
        _vm.modalClose($event);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showEditShade) ? _c('EditShade', {
    on: {
      "hideEditShade": function($event) {
        _vm.modalClose($event);
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-452f739e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/Teinte.vue
// module id = 3152
// module chunks = 0